<script>
    import Page from '../components/Page/Page.svelte';
    import {permissions, questions, survey, surveyTitle} from '../stores';
    import {txt} from '../i18n/i18n';
    import {afterUpdate} from 'svelte';
    import UserContent from "./UserContent/UserContent.svelte";
    import Question from "./Question/Question.svelte";
    import {navigateToViewSurveyPage} from "../navigation";

    afterUpdate(() => window.print());    
</script>

<Page title={surveyTitle} displayHeading={true} backLinkHref="#survey" backLinkText="{txt('Back_to_survey_details')}" on:click={() => navigateToViewSurveyPage()}>
    <h2 class="header">{txt('Introduction')}</h2>
    <UserContent renderAsHtml={$survey.hasHtml} text={$survey.description} />
 
    {#if $permissions.canModify || $permissions.canModifyInstance || $permissions.canEvaluate}
        {#each $questions as question, i}
            <div class="print-block">
                <h3>{txt('Question_x_of_y', [i + 1, $questions.length])}</h3>
                <Question question={question} questionNumber="{question.orderNo}" totalNumberOfQuestions="{$questions.length}" hideAnswer="{true}" />
            </div>
        {/each}
    {/if}
</Page>